import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import navigationDrawer from "./modules/navigationDrawer";
import market from "./modules/market";
import order from "./modules/order";
import currencies from "./modules/currencies";
import wallets from "./modules/wallet";
import auth from "./modules/auth";
import tradingView from "./modules/tradingVue";
import buySellState from "./modules/buySellState";
import userInfo from "./modules/userInfo";
import orderListStep from "./modules/orderListStep";
import notifications from "./modules/notifications";
import transactions from "./modules/transactions";
// import userInfoV4 from "./modules/userInfoV4";
import init from "./modules/init";
import userVerifyInfo from "./modules/userVerifyInfo";
import operations from "./modules/operations";
import account from "./modules/account";
import identity from "./modules/identity";
import image from "./modules/image";
import mobile from "./modules/mobile";
import phone from "./modules/phone";
import email from "./modules/email";
import ticket from "./modules/ticket";
import transfer from "./modules/transfer";
import secure from "./modules/secure";
import userSetting from "./modules/userSetting";
import marketExchange from "./modules/marketExchange";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    init,
    orderListStep,
    userInfo,
    navigationDrawer,
    market,
    order,
    currencies,
    wallets,
    auth,
    tradingView,
    buySellState,
    notifications,
    transactions,
    // userInfoV4,
    userVerifyInfo,
    operations,
    account,
    identity,
    image,
    mobile,
    phone,
    email,
    ticket,
    transfer,
    secure,
    userSetting,
    marketExchange
  }
});
